import React from 'react';
import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import BookReaderPage from './features/bookReader/BookReaderPage';
import BookListPage from './pages/BookListPage';
import CreateBookPage from './pages/CreateBookPage';
import BookDetailPage from './pages/BookDetailPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-quill-new/dist/quill.snow.css';
import ContactUs from './pages/ContactUs';
import AboutUs from './pages/AboutUs';
import TrainingPrograms from './pages/TrainingPrograms';
import TeamMemberDetail from './pages/TeamMemberDetail';
import NewsUpdates from './pages/NewsUpdates';
import NewsUpdatesPost from './pages/NewsUpdatesPost';
import Innovations from './pages/Innovations';
import ScrollToTop from './pages/ScrollToTop';

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <div className="container-fluid p-0">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />

              <Route path="/about" element={<AboutUs />} />
              <Route path="/about/:slug" element={<TeamMemberDetail />} />
              <Route path="/training-programs" element={<TrainingPrograms />} />
              <Route path="/news-updates" element={<NewsUpdates />} />
              <Route path="/news-updates/:postId" element={<NewsUpdatesPost />} />
              <Route path="/contacts" element={<ContactUs />} />
              <Route path="/innovations" element={<Innovations/>} />

              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } 
              />
              {/* Book and Chapter Routes */}
              <Route path="/books" element={<ProtectedRoute><BookListPage /></ProtectedRoute>} />
              <Route path="/create-book" element={<ProtectedRoute><CreateBookPage /></ProtectedRoute>} />
              <Route path="/book/:bookId" element={<ProtectedRoute><BookDetailPage /></ProtectedRoute>} />
          {/* XML Book Reader (if keeping) - ensure path doesn't conflict if bookId is just a number */}
          {/* <Route path="/xml-book/:bookId" element={<ProtectedRoute><BookReaderPage /></ProtectedRoute>} /> */}

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </div>
      </BrowserRouter>
    </Provider>
  );
}

export default App; 